<template>
  <transition name="backtop-bounce">
    <div
      v-show="visible"
      class="v-backtop-wrapper"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    >
      <!-- 悬浮微提示气泡（含滚动百分比） -->
      <transition name="tooltip-fade">
        <div class="backtop-tooltip" v-if="isHover">
          <span class="tooltip-text">返回顶部</span>
          <span class="tooltip-percent" v-if="scrollProgress > 0">{{ scrollProgress }}%</span>
        </div>
      </transition>

      <!-- 返回顶部核心按钮 -->
      <div
        class="v-backtop-btn"
        ref="vBackTop"
        @click="backtop"
        title="返回顶部"
        aria-label="返回页面顶部"
      >
        <!-- 环形滚动进度条 (SVG Progress Ring) -->
        <svg class="progress-ring" width="48" height="48" viewBox="0 0 48 48">
          <defs>
            <linearGradient id="backtopGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#10b981" />
              <stop offset="100%" stop-color="#059669" />
            </linearGradient>
          </defs>
          <!-- 底层轨道 -->
          <circle
            class="progress-ring-track"
            cx="24"
            cy="24"
            r="21.5"
            stroke-width="2.2"
          />
          <!-- 动态进度条 -->
          <circle
            class="progress-ring-circle"
            cx="24"
            cy="24"
            r="21.5"
            stroke-width="2.5"
            :style="{
              strokeDasharray: circumference,
              strokeDashoffset: strokeDashoffset
            }"
          />
        </svg>

        <!-- 工业高定微型顶部指示图标 -->
        <svg class="backtop-arrow-svg" viewBox="0 0 24 24" width="18" height="18" fill="none">
          <path d="M12 4.5L5.5 11L6.9 12.4L11 8.3V19H13V8.3L17.1 12.4L18.5 11L12 4.5Z" fill="currentColor"/>
          <path d="M5.5 2.5H18.5V4H5.5V2.5Z" fill="currentColor" opacity="0.85"/>
        </svg>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "v-backtop",
  data() {
    return {
      visible: false,
      isHover: false,
      scrollProgress: 0,
      radius: 21.5,
    };
  },
  computed: {
    // 进度圆周长: 2 * π * r ≈ 135.08
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    // 根据当前滚动百分比动态计算描边偏移
    strokeDashoffset() {
      const progress = Math.min(100, Math.max(0, this.scrollProgress));
      return this.circumference - (progress / 100) * this.circumference;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    // 监听窗口滚动，动态计算页面阅读进度并控制显隐
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
      const clientHeight = window.innerHeight || document.documentElement.clientHeight || 0;

      this.visible = scrollTop > 320;

      const totalScroll = scrollHeight - clientHeight;
      if (totalScroll > 0) {
        this.scrollProgress = Math.min(100, Math.max(0, Math.round((scrollTop / totalScroll) * 100)));
      } else {
        this.scrollProgress = 0;
      }
    },
    // 平滑返回顶部动效
    backtop() {
      if (window.$ && $.fn && $.fn.velocity) {
        $("html, body").velocity("scroll", {
          offset: 0,
          duration: 400,
          easing: "ease-out",
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-backtop-wrapper {
  position: fixed;
  right: 28px;
  bottom: 84px;
  z-index: 99;
  display: flex;
  align-items: center;
  user-select: none;
}

/* 悬浮微胶囊标签 */
.backtop-tooltip {
  position: absolute;
  right: calc(100% + 12px);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: rgba(15, 23, 42, 0.88);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 0.5px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  white-space: nowrap;
  pointer-events: none;

  .tooltip-text {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 0.02em;
  }

  .tooltip-percent {
    font-size: 11px;
    font-weight: 700;
    color: #34d399;
    background: rgba(52, 211, 153, 0.18);
    padding: 1px 6px;
    border-radius: 8px;
  }
}

/* 核心按钮 */
.v-backtop-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.95);
  box-shadow: 0 8px 24px -2px rgba(13, 148, 136, 0.22),
              0 2px 8px -1px rgba(0, 0, 0, 0.06),
              inset 0 1px 1px rgba(255, 255, 255, 0.9);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

  /* SVG 环形进度条 */
  .progress-ring {
    position: absolute;
    top: 0;
    left: 0;
    transform: rotate(-90deg); /* 从正顶部 12 点钟方向顺时针旋转 */
    pointer-events: none;

    .progress-ring-track {
      fill: none;
      stroke: rgba(16, 185, 129, 0.14);
    }

    .progress-ring-circle {
      fill: none;
      stroke: url(#backtopGrad);
      stroke-linecap: round;
      transition: stroke-dashoffset 0.15s ease-out;
    }
  }

  .backtop-arrow-svg {
    color: #0d9488;
    z-index: 1;
    transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), color 0.25s ease;
    filter: drop-shadow(0 1px 1px rgba(13, 148, 136, 0.2));
  }

  &:hover {
    transform: translateY(-4px) scale(1.06);
    background: #0d9488;
    border-color: #0d9488;
    box-shadow: 0 12px 28px -2px rgba(13, 148, 136, 0.42),
                0 4px 10px rgba(0, 0, 0, 0.1);

    .backtop-arrow-svg {
      color: #ffffff;
      transform: translateY(-2px);
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
    }

    .progress-ring .progress-ring-track {
      stroke: rgba(255, 255, 255, 0.25);
    }

    .progress-ring .progress-ring-circle {
      stroke: #ffffff;
    }
  }

  &:active {
    transform: translateY(-1px) scale(0.96);
  }
}

/* 动效 transitions */
.backtop-bounce-enter-active,
.backtop-bounce-leave-active {
  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.backtop-bounce-enter {
  opacity: 0;
  transform: translateY(28px) scale(0.6);
}

.backtop-bounce-leave-to {
  opacity: 0;
  transform: translateY(16px) scale(0.7);
}

.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.tooltip-fade-enter {
  opacity: 0;
  transform: translateX(8px);
}

.tooltip-fade-leave-to {
  opacity: 0;
  transform: translateX(6px);
}

@media (max-width: 600px) {
  .v-backtop-wrapper {
    right: 18px;
    bottom: 74px;
  }
  .v-backtop-btn {
    width: 44px;
    height: 44px;

    .progress-ring {
      width: 44px;
      height: 44px;
    }
  }
}
</style>
